/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { Control, Controller, ControllerProps, FieldError, useController } from "react-hook-form"

import { Checkbox, CheckboxProps, FormControl, FormControlLabel, FormHelperText, TextFieldProps } from "@mui/material";

export type TextFieldElementProps = Omit<CheckboxProps,
  'name'> & {
    validation?: ControllerProps['rules']
    name: string
    parseError?: (error: FieldError) => string
    control?: Control<any, any>
    label?: string
    maxLength?:number
  }

export default function CustomCheckBox({
  validation = {},
  parseError,
  required,
  name,
  control,
  sx,
  label,
  maxLength,
  ...rest
}: TextFieldElementProps): JSX.Element {

  let { field: { value, onChange }, fieldState: { error } } = useController({
    name: name,
    // rules: attributeInputCallback.isRequired() ? { required: 'This field is required' } : undefined,
    control: control
  })

  if (required) {
    validation.required = 'This field is required'
  }


  return (
    <Controller
      name={name}
      control={control}
      rules={validation}
      render={({ field: { value, onChange, onBlur }, fieldState: { invalid, error } }) =>
        <>
        <div style={{marginBottom:"16px"}}>
          <FormControl  id={name+'_formControl'} error={!!error} fullWidth>
          <FormControlLabel className="customCheckBoxFieldLabel" control={<Checkbox className="customCheckboxField"
            name={name}
            value={value}
            checked={!!value}
            onChange={()=>{
                onChange(!value);
            }}
            required={required}
            {...rest}
            />}
            label={<span dangerouslySetInnerHTML={{__html:label ? label :''}}></span>}
            />

            {!!error && <FormHelperText>{error?.message}</FormHelperText>}
          </FormControl>
          </div>
        </>
      }
    />


  )
}